import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { SkillsImportHttpClient } from './skills-import.http-client';
import { SkillsImportActions } from './skills-import.store';

@Injectable({ providedIn: 'root' })
export class SkillsImportEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(SkillsImportHttpClient);

  public effects = createEffectFactory(SkillsImportActions, this.actions$);

  public createImport$ = this.effects(SkillsImportActions.createImport, ({ payload }) =>
    this.http.createImport(payload).pipe(
      map(data => SkillsImportActions.createImportSuccess({ payload: { data } })),
      catchError((err: HttpErrorResponse) =>
        of(SkillsImportActions.createImportFailed({ payload: err.error })),
      ),
    ),
  );

  public submitImport$ = this.effects(SkillsImportActions.submitImport, ({ payload }) =>
    this.http.submitImport(payload.importId, payload.userPrompt).pipe(
      map(() =>
        SkillsImportActions.submitImportSuccess({ payload: { importId: payload.importId } }),
      ),
      catchError((err: HttpErrorResponse) =>
        of(SkillsImportActions.submitImportFailed({ payload: err.error })),
      ),
    ),
  );

  public fetchImport$ = this.effects(SkillsImportActions.fetchImport, ({ payload }) =>
    this.http.getImport(payload.id).pipe(
      map(data => SkillsImportActions.fetchImportSuccess({ payload: { data } })),
      catchError((err: HttpErrorResponse) =>
        of(SkillsImportActions.fetchImportFailed({ payload: err.error })),
      ),
    ),
  );
}
